import formatMediaObject from '../utils/formatters/format-media-object';

/**
 * Format Recipe Listings API data.
 *
 * @param {object} context
 * @param {Array} listings
 *
 * @returns {Array}
 */
export const formatRecipeListings = (context, listings = []) => {
    return listings.map((listing) => ({
        name: listing.name,
        description: listing.description,
        image: formatMediaObject.call(context, listing.desktop_image),
        to: listing.page?.uri,
        note: listing.recipe_tag,
    }));
};

/**
 * Format Recipe Categories API data.
 *
 * @param {Array} categories
 *
 * @returns {Array}
 */
export const formatRecipeCategories = (categories = []) => {
    return categories.map((category) => ({
        text: category.name,
        value: category.slug,
    }));
};

/**
 * Format recipes for display in their card form.
 *
 * @param {object} context
 * @param {Array} recipes
 *
 * @returns {{image: {src: string, alt: string}, note: string, name: string, description: string, to: string}[]}
 */
export const formatRecipesForCards = (context, recipes = []) => {
    return recipes.map((recipe) => ({
        name: recipe.name,
        description: recipe.description,
        image: formatMediaObject.call(context, recipe.desktop_image),
        to: recipe.page?.uri,
        note: recipe.recipe_tag,
    }));
};
